export default __webpack_public_path__ + "static/world-bunny-team-map-d4ebe4b2d61fd9d5ddda826c1fc48363.svg";